export const AwardIcon = ({ className, color = "currentColor" }: { className?: string; color?: string }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.5 10.5C11.2614 10.5 13.5 8.26142 13.5 5.5C13.5 2.73858 11.2614 0.5 8.5 0.5C5.73858 0.5 3.5 2.73858 3.5 5.5C3.5 8.26142 5.73858 10.5 8.5 10.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.63333 9.72668L4.83333 16.1667L8.5 14.1667L12.1667 16.1667L11.3667 9.72002"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
